/**
 * Port von `Client/Components/Sidebar/IwmSidebarRechnung.razor`, seit REQ-27 als `Drawer`
 * (REQ-25 §1) statt `SidebarShell`.
 */

import { ReceiptForm } from '@/components/forms/ReceiptForm';
import { Drawer } from '@/components/ui';
import type { SidebarPosition } from '@/components/ui/types';

import { useOpenNotification } from './useOpenNotification';

/** Breite der fachlichen Schubladen (REQ-27 §2.1). */
const WIDTH = '720px';

export interface ReceiptSidebarProps {
  open: boolean;
  /** Standard 0 → neue Rechnung. */
  receiptId?: number;
  /**
   * Ohne Wirkung: Die Schublade hängt per Portal am `body` und liegt über der ganzen Seite,
   * nicht in einem `target`. Die Eigenschaften bleiben, weil die View-Seiten sie weiter
   * übergeben (REQ-27 §2.1).
   */
  position?: SidebarPosition;
  target?: string;
  onShow?(): void;
  onHide(): void;
}

export function ReceiptSidebar(props: ReceiptSidebarProps) {
  useOpenNotification(props.open, () => {
    props.onShow?.();
  });

  const hide = () => {
    props.onHide();
  };

  // Geschlossen rendert die Schublade nichts (REQ-25 §1); das Formular lädt deshalb erst
  // beim Öffnen und beginnt bei jedem Öffnen frisch.
  if (!props.open) return null;

  return (
    <ReceiptForm
      id={props.receiptId ?? 0}
      onSave={hide}
      onCancel={hide}
      shell={({ title, footer, children }) => (
        <Drawer open title={title} width={WIDTH} footer={footer} onClose={hide}>
          {children}
        </Drawer>
      )}
    />
  );
}

export default ReceiptSidebar;
